import { RavenLogoSvgOrWhitelabelLogo } from "components/Nav/RavenLogo/RavenLogo";
import styled, { createGlobalStyle } from "styled-components/macro";

const getContentHeight = ({
  $isWindows,
  $isLandscape = false,
}: {
  $isWindows: boolean;
  $isLandscape?: boolean;
}) => {
  const heightLandscape = $isWindows ? 7.1 : 7;
  const heightPortrait = $isWindows ? 9.6 : 9.5;
  return $isLandscape ? heightLandscape : heightPortrait;
};

type PrintableReportStylesProps = {
  $isLandscape?: boolean;
  $height?: number; // this is in inches
  $isWindows: boolean;
};

export const PrintableReportStyles = styled.div<PrintableReportStylesProps>`
  @media print {
    height: ${props =>
      props.$height ?? getContentHeight({ ...props })}in !important;
    margin: 0 !important;

    .break-after {
      display: block;
      break-after: page;
      position: relative;
    }

    #noPrint {
      display: none;
    }

    #print {
      display: initial !important;
    }

    @page {
      size: ${props => (props.$isLandscape ? "landscape" : "portrait")};
    }
  }
`;

export const PrintableReportGlobalStyles = createGlobalStyle`
@media print{
  [data-component-name="Navbar"]{
    display:none;
  }
  [class*="ReportHeader__RavenHeaderStyles"]{
    z-index:-2;
  }
  [class*="PrintableReportStyles"]{
    margin-top: 60px !important;
  }
  .generic-eos-page-break{
    height: 108px;
  }
}
`;
export const PrinterOnlyRavenLogo = () => {
  return (
    <Styles>
      <RavenLogoSvgOrWhitelabelLogo />
    </Styles>
  );
};
const Styles = styled.div`
  display: none;
  @media print {
    display: block;
  }
  position: fixed;
  z-index: -1;
  top: 10px;
  right: 10px;
`;
